export const privacyContent = `
# Política de privacidad

_En vigor desde 1 de julio de 2026_

## 1. ¿Quién es el responsable del tratamiento de tus datos?

Data Lab es un espacio de datos prestado por Adigital:

- *Denominación social*: Asociación Española de la Economía Digital
- *NIF*: G61668505
- *Dirección postal*: Avenida Diagonal, 530, 2ª planta, oficina 209, (Coworking Utopicus), 08006-Barcelona, Barcelona, España.
- *Correo electrónico*: info@datalab.adigital.es.

Puedes ponerte en contacto con nuestro delegado de protección de datos en protecciondatos@adigital.org.

## 2. ¿Con qué finalidades y legitimación tratamos tus datos personales?

Tratamos tus datos para prestarte los servicios asociados a Data Lab que nos solicitas, como gestionar tu acceso a la plataforma o explorar las fuentes disponibles.

Si nos das tu consentimiento, también utilizaremos tus datos para enviarte por medios electrónicos, incluyendo email, las novedades relacionadas con Data Lab e información sobre nuestras actividades de formación y promoción de Data Lab.

No tomamos decisiones automatizadas ni elaboramos perfiles en base a tus datos. Tampoco realizamos transferencias internacionales de tus datos personales.


## 3. ¿De dónde proceden y cuáles son los datos personales que tratamos?

Lso datos personales que son los que nos proporcionas tú directamente durante el proceso de registro y durante el uso de los servicios como, por ejemplo, cuando modificas tu perfil. Si tu usuario de acceso a Data Lab ha sido creado por tu empresa, es posible que hayamos obtenido tus datos a través de ella.

Para garantizar la seguridad de Data Lab y tu privacidad, también guardamos tu actividad dentro de la plataforma, como la hora y navegador desde el que accedes o desde el que modificas tus datos, o los paneles, consultas o datos que visualizas.

Por motivos de seguridad y calidad, si te pones en contacto con nosotros por correo electrónico guardaremos los mensajes.

## 4. ¿Cuáles son tus derechos en relación con los datos que tratamos?

En relación con tus datos, tienes los siguientes derechos:

- Derecho a saber si estamos tratando tus datos personales, a acceder a ellos y a solicitar información acerca de cómo y por qué los tratamos y, en su caso, solicitar una copia, incluso en formato estructurado, de uso común y de lectura mecánica. 
- Derecho a rectificar y modificar los datos cuando no sean correctos o sean inexactos y solicitar su supresión, cuando ya no sean necesarios para los fines para los que los recogimos.
- Por motivos relacionados con tu situación particular, tienes derecho a oponerte a que tratemos tus datos.
- En determinadas circunstancias, tienes derecho a solicitar que limitemos el tratamiento de tus datos, en cuyo caso únicamente los conservaremos para el ejercicio y defensa de reclamaciones, para aquello para lo que nos des tu consentimiento o para atender responsabilidades legales.
- Derecho a presentar una reclamación ante la Agencia Española de Protección de Datos si consideras que no hemos atendido adecuadamente tus derechos.
- El ejercicio y alcance de tus derechos está regulado por la normativa aplicable.

Puedes ejercer tus derechos accediendo a la aplicación web de Data Lab o solicitándonoslo a través de un correo electrónico dirigido a la dirección indicada al comienzo de esta política de privacidad.

## 5. ¿Durante cuánto tiempo conservaremos los datos?

Conservaremos tus datos mientras no te des de baja del servicio. Puedes darte de baja en cualquier momento a través de tu panel de usuario o poniéndote en contacto directamente con nosotros a través de correo electrónico en la dirección indicada al comienzo de esta política.

No obstante, cuando nos solicites por los medios establecidos la supresión de tus datos, de acuerdo con la normativa aplicable, estos se mantendrán debidamente bloqueados sin que los usemos, mientras puedan ser necesarios para el ejercicio o defensa de reclamaciones o pueda derivarse de su tratamiento algún tipo de responsabilidad legal o contractual para lo cual sea necesaria su recuperación. Una vez transcurrido este plazo de tiempo, tus datos serán eliminados definitivamente.

Las conversaciones telefónicas almacenadas por motivos de seguridad y calidad pueden ser conservadas durante 3 años. 

## 6. Cambios en la política de privacidad y cookies

Adigital puede modificar la información establecida en esta política de privacidad sin previo aviso.

`
